export const INTEGRATIONS_PLATFORM = 'INTEGRATIONS_PLATFORM';
export const HUBSPOT_MEETINGS = 'HUBSPOT_MEETINGS';
export const VOIP = 'VOIP'; // Aka Twilio
export const ZOOM = 'ZOOM';
export const isCallSourceType = source => {
  return source === INTEGRATIONS_PLATFORM || source === VOIP || source === ZOOM || source === HUBSPOT_MEETINGS;
};